import { useDispatch } from 'react-redux'
import { discardProjectOrderlinesMailDraft } from '../../../../../features/projectManagement/projectManagementSlice'
import ProjectService from '../../../../../services/ProjectService'

export const useDiscardDraft = () => {
  const dispatch = useDispatch()

  const removeDraftFromStore = (id: string) => {
    dispatch(discardProjectOrderlinesMailDraft({ id }))
  }

  const discardDraft = (id: string) => {
    ProjectService.discardHandlerAssignmentMailDraft(id)
    removeDraftFromStore(id)
  }

  return { discardDraft, removeDraftFromStore }
}
